module.exports = __webpack_public_path__ + "edit.c2b97d8c472b2b1f8d4b8b01436b7452.svg";